import db from '../../firebase/firebaseInit'
import firebase from 'firebase'
export default {
  state: {
    blogs: []
  },

  getters: {
    allBlogs: state => state.blogs
  },

  mutations: {
    setBlogs: (state, blogs) => (state.blogs = blogs),
    deleteBlogs: (state, blogs) => (state.blogs = blogs)
  },

  actions: {
    // live con db todos
    async fetchBlogs () {
      let list = []
      db.collection('blogs').onSnapshot(res => {
        const changes = res.docChanges()
        changes.forEach(change => {
          const { newIndex, oldIndex } = change
          if (change.type === 'added') {
            const data = {
              id: change.doc.id,
              ...change.doc.data()
            }
            list.push(data)
          } else if (change.type === 'modified') {
            list.splice(oldIndex, 1)
            var newdata = {
              id: change.doc.id,
              ...change.doc.data()
            }
            list.splice(newIndex, 0, newdata)
          } else if (change.type === 'removed') {
            list.splice(oldIndex, 1)
          }
          this.commit('setBlogs', list)
        })
      })
    },

    // voeg todo toe in todos in db
    async voegBlogToe (context, payload) {
      try {
        db.collection('blogs')
          .doc((context.state.blogs.length + 1).toString())
          .set({
            ...payload,
            datum: new Date().toLocaleDateString(),
            body: payload.bodyHTML.replace(/<(.|\n)*?>/g, ''),
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
          })
          .then(function () {
            console.log('todo toegevoegd in todos in db')
          })
      } catch (error) {
        console.error('Error writing document: ', error)
        alert(
          'Opslaan niet gelukt... Probeer het opnieuw of neem contact op met Christiaan'
        )
      }
    },

    async updateBlog (context, payload) {
      try {
        db.collection('blogs')
          .doc(payload.id)
          .update(payload)
          .then(() => {
            db.collection('blogs')
              .doc('blogsinfo')
              .update({
                [payload.id]: {
                  ...payload,
                  body: payload.bodyHTML.replace(/<(.|\n)*?>/g, '')
                }
              })
          })
      } catch (error) {
        alert(
          'opslaan niet gelukt... Probeer het opnieuw of neem contact op met Christiaan'
        )
      }
    },

    // verwijder toe uit todos in db
    async verwijderBlog (context, payload) {
      try {
        db.collection('blogs')
          .doc(payload)
          .delete()
          .then(function () {
            db.collection('blogs')
              .doc('blogsinfo')
              .update({
                [payload]: firebase.firestore.FieldValue.delete()
              })
            console.log('todo verwijderd uit todos in db')
          })
      } catch (error) {
        console.error('Error deleting document: ', error)
        alert(
          'Verwijderen niet gelukt... Probeer het opnieuw of neem contact op met Christiaan'
        )
      }
    }
  }
}
